<template>
  <!-- 讲堂-报告详情 -->
  <div class="masterInfoWrap">
      <div class="masterData">
        <h1>{{detail.title}}</h1>
        <div class="souce clearfix">
          <v-userinfoimg :src="userData.headImage" :accountId="detail.accountId"></v-userinfoimg>
          <span class="userName">{{userData.userName}}</span>
          <span>阅读 {{detail.readTotal}}</span>
          <div style="float:right" v-if="detail.accountId!=$route.query.accountId">
            <div class="follow" v-if="isFllow == 0" @click="clickFollow()">关注</div>
            <div class="follow isFollow" v-else @click="clickFollow()">已关注</div>
          </div>
          
        </div>
        <div class="masterInfoContent" v-html="detail.detail"></div>
      </div>
      <!-- 点赞 -->
      <div class="fabulousWrap">
        <div class="fabulous" v-if="isFabulous == 0" @click="clickFabulous()"><img src="../images/fabulous.png" alt="">{{fabulousNumber}}</div>        
        <div class="fabulous not" @click="clickFabulous()"  v-else><img src="../images/fabulous2.png" alt="">{{fabulousNumber}}</div>        
      </div>
      <!-- 点赞列表 -->
      <div class="fabulousList clearfix">
        <div class="list">
          <div class="imgbox" v-for="item in goodData">
            <img :src="item.headImage?item.headImage:require('../images/headerImg.png')" alt="">
          </div>
          
        </div>
        <div class="number" @click="toList">{{fabulousNumber}} 赞过 ></div>
      </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
      detail: '',//页面基础数据
      userData:'',
      goodData:'',
      isFabulous:'',
      isFllow:'',
      token:"",
      isFabulousData:0,
      fabulousNumber:0,
    }
  },
  created(){
    this.init(1);
  },
  mounted(){
    window.getToken = this.getToken;
    if(global.getmobiletype()=="android"){
      this.token = control.getToken()
    }
    else{
      window.webkit.messageHandlers.getToken.postMessage({"mothedName":"getToken"});
    }
  },
  methods:{
    getToken(token){
      this.token = token;
    },
    init(type){
      // this.$http.get("content/bigshot/report?bigShotId="+"5a7fdcc4d761db0001b9b176"+"&contentId="+"5a813993e592ee0001c6a812"+"&accountId="+'32')
      this.$http.get("content/bigshot/report?bigShotId="+this.$route.query.bigShotId+"&contentId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId)
				.then((response) => {
          this.userData = response.respData.bigShotDetails.bigShot;
          this.detail = response.respData.content;
          this.goodData = response.respData.fabulous;
          this.isFabulous = response.respData.isFabulous;
          this.isFllow = response.respData.isFllow;    
          this.fabulousNumber = response.respData.content.fabulousTotal
          // if(this.isFabulousData == 0 && type == 1){
          //   this.fabulousNumber = response.respData.content.fabulousTotal
          // }
          // if(this.isFabulousData == 1 && type == 1){
          //   this.fabulousNumber = this.fabulousNumber + 1
          // }else if(this.isFabulousData == 2 && type == 1){
          //   this.fabulousNumber = this.fabulousNumber - 1
          // }
			});
    },
    clickFabulous(){//点赞
      Indicator.open();
      
      this.$http.post("content/praise?contentType="+"1"+"&contentId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId,"",{headers:{"Authorization":"bearer "+this.token+""}})
				.then((response) => {
          Indicator.close();
          this.init(1);
          if(global.getmobiletype()=="android"){
            control.getFabulousStatus(String(response.respData));
          }
          else{
            window.webkit.messageHandlers.getFabulousStatus.postMessage(String(response.respData));
          }
			});
    },
    clickFollow(){//关注
      Indicator.open();
      // this.$http.post("content/bigshot/follower?bigShotId="+this.userData.accountId+"&contentId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId+"&contentType=1","",{headers:{"Authorization":"bearer c24c0297b8961d1ee572108d9f359397"}})
      this.$http.post("account/save/attention/fans?bigShotId="+this.userData.accountId+"&contentId="+this.$route.query.contentId+"&accountId="+this.userData.accountId+"&contentType=1","",{headers:{"Authorization":"bearer "+this.token+""}})
				.then((response) => {
          Indicator.close();
          this.init(2);
			});
    },
    toList(){//点赞列表
      if(global.getmobiletype()=="android"){
        control.toFabulousList();
      }
      else{
        window.webkit.messageHandlers.getFabulousList.postMessage('');
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.masterInfoWrap{
  width: 100%;
  height: auto;
  .masterData{
    padding: 0.4rem;
    h1{
      line-height: 0.75rem;
      font-size: 0.53rem;
      color: #333440;
      font-weight: bold;
      margin-bottom: 0.27rem;
    }
    .souce{
      font-size: 0.32rem;
      color: #A4A4A4;
      margin-bottom: 0.37rem;
      line-height: 0.91rem;
      .userName{
        font-size: 0.32rem;
        color: #333440;
        margin: 0 0.21rem 0 0.27rem;
      }
      .follow{
        float: right;
        width: 1.6rem;
        height: 0.72rem;
        background-image: linear-gradient(-270deg, #EF4B4B 4%, #F7643C 100%);
        box-shadow: 0 0.08rem 0.16rem 0 rgba(239,75,75,0.30);
        border-radius: 2.67rem;
        text-align: center;
        line-height: 0.72rem;
        color: #fff;
        font-size: 0.32rem;
        margin-top: 0.1rem;
      }
      .isFollow{
        background: #FFF1EF;
        color: #E27574;
        background-image: none;
        box-shadow: none;
      }
    }
  }
  
  .fabulousWrap{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.8rem 0 ;
    .fabulous{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.73rem;
      height: 0.96rem;
      line-height: 0.96rem;
      border: 0.03rem solid #D1D1D1;
      border-radius: 2.67rem;
      text-align: center;
      font-size: 0.29rem;
      color: #A4A4A4;
      img{
        width: 0.59rem;
        height: 0.53rem;
        margin-right: 0.05rem;
      }
    }
    .not{
      img{
        width: 0.69rem;
        height: 0.64rem;
      }
    }
  }
  .fabulousList{
    height: 1.28rem;
    line-height: 1.28rem;
    border-top: 0.03rem solid #EFEFEF;
    border-bottom: 0.03rem solid #EFEFEF;
    padding: 0 0.32rem 0 0.4rem;
    .list{
      .imgbox{
          display: flex;
          float: left;
          justify-content: center;
          -ms-flex-align: center;
          align-items: center;
          width: .69rem;
          height: .69rem;
          border-radius: 100%;
          margin-top: .266667rem;
          margin-right: .16rem;
          overflow: hidden;
        img{
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .number{
      float: right;
      font-size: 0.29rem;
      color: #A4A4A4;
    }
  }
}
</style>
<style lang="less">
  .masterInfoContent{
    width:100%;
    overflow: hidden;
    font-size:32px;
    img,video,table{
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/reportInfo.vue